module.exports = __webpack_public_path__ + "public/images/phone-with-dog.dba3a2d178f5e0a106337ed45748242b.png";